import "./_LayoutInicial.scss";

const LayoutInicial = (props) => {
  return <div className="layoutInicial">{props.children}</div>;
};

export default LayoutInicial;
